export const KEY_EVENT = 'event';
export const KEY_DETAIL = 'detail';
export const KEY_CHANGE = 'change';
export const KEY_REQUEST = 'request';
export const KEY_DISPATCH = 'dispatch';
